module.exports = __webpack_public_path__ + "img/bg-class.e2afcce6.jpg";